import React from 'react';
import { Flex, SpacingStack, TextV2 } from '@withjoy/joykit';
import { StyledPhoto, StyledDiv, FadeInWrapper, StyledColumnsContainer, styles, StyledConfirmationContainer } from './CashFundConfirmation.styles';
import { ReactComponent as Checkmark } from '@assets/icons/check-mark.svg';
import { useTranslation } from '@shared/core';
import { ProductCatalogCollectionMembersFragment } from '@graphql/generated';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import CashFundCollectionMembers from './CashFundCollectionMembers';
import { CatalogDepartmentDictionaryEntry } from '../../../Catalog/state/Catalog';

export interface CashFundConfirmationProps {
  photoUrl?: string;
  cashFundTitle: string;
  collectionMembers: Maybe<ProductCatalogCollectionMembersFragment[]>;
  selectedCategory: Maybe<CatalogDepartmentDictionaryEntry>;
  handleViewRegistry: () => void;
}

export const CashFundConfirmation: React.FC<CashFundConfirmationProps> = ({ photoUrl, cashFundTitle, collectionMembers, selectedCategory, handleViewRegistry }) => {
  const { t } = useTranslation('catalogRegistry');
  const isMobile = useIsMobileScreen();

  const translations = t('cashFundCatalog');

  const hasCollectionMembers = !!collectionMembers?.length;

  return (
    <FadeInWrapper>
      <StyledColumnsContainer
        spacing={[6, 0]}
        stack={isMobile ? 'vertical' : 'horizontal'}
        __css={styles.columnsContainerStyles}
      >
        <StyledConfirmationContainer __css={styles.confirmationContainerStyles(hasCollectionMembers)}>
          <SpacingStack spacing={5}>
            <StyledPhoto photoUrl={photoUrl}>
              <StyledDiv>
                <Checkmark />
              </StyledDiv>
            </StyledPhoto>
            <TextV2
              textAlign="center"
              component="h1"
              typographyVariant="hed2"
              fontSize={24}
            >
              {translations.fundAddedTitle({ title: cashFundTitle })}
            </TextV2>
            <TextV2
              textAlign="center"
              component="h2"
              typographyVariant="body1"
            >
              {translations.fundSuccessSubtitle()}
            </TextV2>
            <Flex justifyContent="center">
              <TextV2
                textAlign="center"
                typographyVariant="button2"
                borderBottom="1px solid"
                borderColor="mono5"
                cursor="pointer"
                onClick={handleViewRegistry}
              >
                {translations.viewRegistry()}
              </TextV2>
            </Flex>
          </SpacingStack>
        </StyledConfirmationContainer>
        {hasCollectionMembers && (
          <CashFundCollectionMembers
            cashFundTitle={cashFundTitle}
            collectionMembers={collectionMembers}
            selectedCategory={selectedCategory}
          />
        )}
      </StyledColumnsContainer>
    </FadeInWrapper>
  );
};
